'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _align2 = require('./align');

var _align3 = _interopRequireDefault(_align2);

var _center2 = require('./center');

var _center3 = _interopRequireDefault(_center2);

var _column2 = require('./column');

var _column3 = _interopRequireDefault(_column2);

var _flexContainer = require('./flex-container');

var _flexContainer2 = _interopRequireDefault(_flexContainer);

var _masonry = require('./masonry');

var _move2 = require('./move');

var _move3 = _interopRequireDefault(_move2);

var _offset2 = require('./offset');

var _offset3 = _interopRequireDefault(_offset2);

var _row2 = require('./row');

var _row3 = _interopRequireDefault(_row2);

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

var _waffle2 = require('./waffle');

var _waffle3 = _interopRequireDefault(_waffle2);

var _defaults = require('./defaults');

/**
 * Main Perdido class.
 *
 * @api public
 */

var Perdido = (function () {
  function Perdido() {
    var gutter = arguments.length <= 0 || arguments[0] === undefined ? _defaults.GUTTER : arguments[0];
    var flex = arguments.length <= 1 || arguments[1] === undefined ? _defaults.FLEX : arguments[1];
    var cycle = arguments.length <= 2 || arguments[2] === undefined ? _defaults.CYCLE : arguments[2];
    var offsetDir = arguments.length <= 3 || arguments[3] === undefined ? _defaults.OFFSET_DIR : arguments[3];

    _classCallCheck(this, Perdido);

    // Set the default values.
    this.gutter = gutter;
    this.flex = flex;
    this.cycle = cycle;
    this.offsetDir = offsetDir;

    // Simple properties/methods.
    this.flexContainer = _flexContainer2['default'];
    this.utils = utils;
  }

  /**
   * Creates a new instance of Perdido.
   *
   * @see Perdido
   * @api public
   */

  Perdido.prototype.create = function create() {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var _ref$gutter = _ref.gutter;
    var gutter = _ref$gutter === undefined ? _defaults.GUTTER : _ref$gutter;
    var _ref$flex = _ref.flex;
    var flex = _ref$flex === undefined ? _defaults.FLEX : _ref$flex;
    var _ref$cycle = _ref.cycle;
    var cycle = _ref$cycle === undefined ? _defaults.CYCLE : _ref$cycle;
    var _ref$offsetDir = _ref.offsetDir;
    var offsetDir = _ref$offsetDir === undefined ? _defaults.OFFSET_DIR : _ref$offsetDir;

    return new Perdido(gutter, flex, cycle, offsetDir);
  };

  /**
   * Aligns nested elements.
   *
   * @see align
   * @api public
   */

  Perdido.prototype.align = function align(alignment) {
    var _ref2 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref2$flex = _ref2.flex;
    var flex = _ref2$flex === undefined ? this.flex : _ref2$flex;

    return _align3['default'](alignment, flex);
  };

  /**
   * Centers a containing element.
   *
   * @see center
   * @api public
   */

  Perdido.prototype.center = function center(maxWidth) {
    var _ref3 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var padding = _ref3.padding;
    var _ref3$flex = _ref3.flex;
    var flex = _ref3$flex === undefined ? this.flex : _ref3$flex;

    return _center3['default'](maxWidth, padding, flex);
  };

  /**
   * Creates a column that is a fraction of its containing element's size.
   *
   * @see column
   * @api public
   */

  Perdido.prototype.column = function column(columnVal) {
    var _ref4 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref4$cycle = _ref4.cycle;
    var cycle = _ref4$cycle === undefined ? this.cycle : _ref4$cycle;
    var _ref4$gutter = _ref4.gutter;
    var gutter = _ref4$gutter === undefined ? this.gutter : _ref4$gutter;
    var _ref4$flex = _ref4.flex;
    var flex = _ref4$flex === undefined ? this.flex : _ref4$flex;

    return _column3['default'](columnVal, cycle, gutter, flex);
  };

  /**
   * Create a column for working with JS Masonry libraries like Isotope.
   *
   * @see masonry.masonryColumn
   * @api public
   */

  Perdido.prototype.masonryColumn = function masonryColumn(columnVal) {
    var _ref5 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref5$gutter = _ref5.gutter;
    var gutter = _ref5$gutter === undefined ? this.gutter : _ref5$gutter;
    var _ref5$flex = _ref5.flex;
    var flex = _ref5$flex === undefined ? this.flex : _ref5$flex;

    return _masonry.masonryColumn(columnVal, gutter, flex);
  };

  /**
   * Create a wrapping element for working with JS Masonry libraries
   * like Isotope.
   *
   * @see masonry.masonryWrap
   * @api public
   */

  Perdido.prototype.masonryWrap = function masonryWrap() {
    var _ref6 = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var _ref6$flex = _ref6.flex;
    var flex = _ref6$flex === undefined ? this.flex : _ref6$flex;
    var _ref6$gutter = _ref6.gutter;
    var gutter = _ref6$gutter === undefined ? this.gutter : _ref6$gutter;

    return _masonry.masonryWrap(flex, gutter);
  };

  /**
   * Source ordering. Shift elements left, right, up, or down.
   *
   * @see move
   * @api public
   */

  Perdido.prototype.move = function move(moveVal) {
    var _ref7 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref7$direction = _ref7.direction;
    var direction = _ref7$direction === undefined ? this.offsetDir : _ref7$direction;
    var _ref7$gutter = _ref7.gutter;
    var gutter = _ref7$gutter === undefined ? this.gutter : _ref7$gutter;

    return _move3['default'](moveVal, direction, gutter);
  };

  /**
   * Margin to the left, right, bottom, or top, of an element.
   *
   * @see offset
   * @api public
   */

  Perdido.prototype.offset = function offset(offsetVal) {
    var _ref8 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref8$direction = _ref8.direction;
    var direction = _ref8$direction === undefined ? this.offsetDir : _ref8$direction;
    var _ref8$gutter = _ref8.gutter;
    var gutter = _ref8$gutter === undefined ? this.gutter : _ref8$gutter;

    return _offset3['default'](offsetVal, direction, gutter);
  };

  /**
   * Creates a row that is a fraction of its containing element's size.
   *
   * @see row
   * @api public
   */

  Perdido.prototype.row = function row(rowVal) {
    var _ref9 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref9$gutter = _ref9.gutter;
    var gutter = _ref9$gutter === undefined ? this.gutter : _ref9$gutter;
    var _ref9$flex = _ref9.flex;
    var flex = _ref9$flex === undefined ? this.flex : _ref9$flex;

    return _row3['default'](rowVal, gutter, flex);
  };

  /**
   * Creates a block that is a fraction of the size of its containing element.
   *
   * @see waffle
   * @api public
   */

  Perdido.prototype.waffle = function waffle(waffleVal) {
    var _ref10 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var _ref10$cycle = _ref10.cycle;
    var cycle = _ref10$cycle === undefined ? this.cycle : _ref10$cycle;
    var _ref10$gutter = _ref10.gutter;
    var gutter = _ref10$gutter === undefined ? this.gutter : _ref10$gutter;
    var _ref10$flex = _ref10.flex;
    var flex = _ref10$flex === undefined ? this.flex : _ref10$flex;

    return _waffle3['default'](waffleVal, cycle, gutter, flex);
  };

  return Perdido;
})();

exports['default'] = Perdido;
module.exports = exports['default'];